var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Headphones"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6172 10.724H15.1172C14.7857 10.724 14.4677 10.8557 14.2333 11.0901C13.9989 11.3245 13.8672 11.6425 13.8672 11.974V15.099C13.8672 15.4305 13.9989 15.7485 14.2333 15.9829C14.4677 16.2173 14.7857 16.349 15.1172 16.349H16.3672C16.6987 16.349 17.0167 16.2173 17.2511 15.9829C17.4855 15.7485 17.6172 15.4305 17.6172 15.099V10.724ZM17.6172 10.724C17.6172 9.7338 17.4212 8.7534 17.0404 7.83936C16.6596 6.92533 16.1015 6.09574 15.3984 5.39848C14.6954 4.70122 13.8612 4.15008 12.944 3.77686C12.0268 3.40365 11.0448 3.21575 10.0547 3.224C9.06518 3.21678 8.08403 3.40545 7.16776 3.77913C6.2515 4.15281 5.41824 4.70411 4.716 5.40127C4.01376 6.09843 3.45642 6.92766 3.07609 7.84119C2.69576 8.75471 2.49997 9.73447 2.5 10.724V15.099C2.5 15.4305 2.6317 15.7485 2.86612 15.9829C3.10054 16.2173 3.41848 16.349 3.75 16.349H5C5.33152 16.349 5.64946 16.2173 5.88388 15.9829C6.1183 15.7485 6.25 15.4305 6.25 15.099V11.974C6.25 11.6425 6.1183 11.3245 5.88388 11.0901C5.64946 10.8557 5.33152 10.724 5 10.724H2.5",
    stroke: "url(#paint0_linear_7937_33984)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7937_33984",
    x1: 14.4105,
    y1: 15.3547,
    x2: 6.43034,
    y2: 2.16249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/Headphones.fbca90116aa3a2ddd66250c034505eee.svg";
export { ForwardRef as ReactComponent };